
import {connect} from "react-redux";
import {shopByIdSelector, shopsSelector} from "../../_data/selectors";
import Booth, {initializeNewBoothShop} from "../../_data/models/Booth";
import BoothFormComponent from "../components/BoothFormComponent";
import {saveBooth} from "../middlewares";
import {toastError, toastSuccess} from "../../_helpers/utils";
import {plainToClass} from "class-transformer";
import {ShopsRoutes} from "../../routes";

const mapDispatchToProps = (dispatch, props) => {
    return {
        onSubmit: (data: Booth) => {
            return dispatch(saveBooth(data , (booth, errors) => {
                if (errors && errors.length) {
                    toastError("Failed to add a new booth for rent.");
                }
                else {
                    toastSuccess("Successfully added a new booth for rent.");
                    props.history.push(ShopsRoutes.viewBooth(booth.shopId, booth.id));
                }
            }));
        }
    };
};

const mapStateToProps = (state, props) => {
    const shop = shopByIdSelector(state, parseInt(props.match.params.shopId));
    const booth = initializeNewBoothShop(shop);
    return {
        booth: booth,
        shop: shop,
        initialValues: booth
    };
};

const AddBoothContainer = connect(mapStateToProps, mapDispatchToProps)(BoothFormComponent);
export default AddBoothContainer;


// WEBPACK FOOTER //
// ./app/client/booth/containers/AddBoothContainer.ts